import React from "react";

export interface GlobalLoaderProps {
    logoSrc?: string;
}

/** Full-screen loader for Suspense fallbacks across Maeiz Workspace applications. */
export const GlobalLoader: React.FC<GlobalLoaderProps> = ({ logoSrc = "/maeiz-icon.png" }) => (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-neutral-light dark:bg-neutral-dark/95 backdrop-blur-sm transition-colors duration-300">
        <div className="relative flex flex-col items-center gap-8">
            {/* Orbital rings */}
            <div className="relative h-24 w-24">
                <div
                    className="absolute inset-0 rounded-full border-2 border-primary/20 dark:border-primary/30"
                    aria-hidden
                />
                <div
                    className="absolute inset-0 animate-spin-slow rounded-full border-2 border-transparent border-t-primary border-r-primary/40"
                    aria-hidden
                />
                <div
                    className="absolute inset-2 animate-spin-slower rounded-full border-2 border-transparent border-b-gold border-l-gold/40"
                    aria-hidden
                />
                {/* Center logo */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <img
                        src={logoSrc}
                        alt=""
                        className="h-12 w-auto opacity-90 dark:opacity-95"
                    />
                </div>
            </div>
            {/* Pulsing dots */}
            <div className="flex items-center gap-1.5" role="status" aria-label="Loading">
                {[0, 1, 2].map((i) => (
                    <div
                        key={i}
                        className="h-2 w-2 rounded-full animate-loader-pulse bg-primary dark:bg-gold"
                        style={{ animationDelay: `${i * 0.16}s` }}
                    />
                ))}
            </div>
        </div>
    </div>
);
